import 'react-app-polyfill/stable';

import TranslationProvider from '@fingo/lib/components/translation/TranslationProvider';
import SnackbarAlert from '@fingo/lib/contexts/snack-bar';
import PropTypes from 'prop-types';
import React from 'react';
import { render } from 'react-dom';
import ApolloProvider from '@fingo/lib/providers/ApolloProvider';
import GoogleTagManagerProvider from '@fingo/lib/providers/GoogleTagManagerProvider';
import UtmCampaignProvider from '@fingo/lib/providers/UtmCampaignProvider';
import MuiProvider from '@fingo/lib/providers/MuiProvider';
import App from './App';

const GlobalProviders = ({ children }) => (
  <MuiProvider>
    <ApolloProvider>
      <GoogleTagManagerProvider>
        {children}
      </GoogleTagManagerProvider>
    </ApolloProvider>
  </MuiProvider>
);

GlobalProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

const ContextProviders = ({ children }) => (
  <TranslationProvider>
    <UtmCampaignProvider>
      <SnackbarAlert />
      {children}
    </UtmCampaignProvider>
  </TranslationProvider>
);

ContextProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

const Fingo = () => (
  <React.StrictMode>
    <GlobalProviders>
      <ContextProviders>
        <App />
      </ContextProviders>
    </GlobalProviders>
  </React.StrictMode>
);

render(<Fingo />, document.getElementById('root'));
